// extracted by mini-css-extract-plugin
module.exports = {"logo":"SimplifiedRoutes_logo__3mz01","simplified":"SimplifiedRoutes_simplified__3Wy0y"};